import { ROUTE_PARAMS } from "constants/routing";

/**
 * Finds the menu item who's path matches the current URL
 * @param {array} menuItems List of menu items to search
 * @param {string} activePath Path of the current URL
 * @returns {object}
 */
export function findActiveMenuItem(menuItems = [], activePath = "") {
  return menuItems.find(({ path } = {}) => activePath.lastIndexOf(path, 0) === 0) || {};
}

/**
 * Finds the menu item who's path matches the current URL
 * @param {object} menuItem Menu item to check for sub menu items
 * @returns {boolean}
 */
export function hasSubMenuItems(menuItem = { subMenuItems: [] }) {
  return Array.isArray(menuItem.subMenuItems) && menuItem.subMenuItems.length > 0;
}

/**
 * Gets the path from a route match object if it exists
 * @param {object|null} match
 */
export function getMatchPath(match) {
  return match && match.path;
}

/**
 * Gets the value of a param from a route match object if it exists
 * @param {object|null} match
 */
export function getMatchParam(match, paramToLog) {
  return match && match.params && match.params[paramToLog];
}

/**
 * Iterates through all route params for a match and returns the last one that exists
 * @param {object|null} match
 */
export function getAnyRouteParam(match) {
  if (!match || !match.params) {
    return {};
  }
  let param = {};
  Object.values(ROUTE_PARAMS).forEach(value => {
    if (match.params[value]) {
      param.name = value;
      param.value = match.params[value];
    }
  });

  return param;
}

/**
 * Joins parts of a page title into a single string
 * @param  {...string} parts Title components to join
 */
export function joinPageTitleParts(...parts) {
  return parts.filter(part => part && part.length > 0).join(" | ");
}
